import { actionBuilder } from './actions';

const moduleBuilder = (client) => {
  return {
    namespaced: true,
    actions: actionBuilder(client),
  };
};

export default { moduleBuilder };
